export const environment = {
    webappsRootURL: 'https://project1apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    clientID : 'c74ea513-b7c9-4d29-850d-e55f4b27adc7', 
    redirectURI: 'https://asbestos.project1.epa.ohio.gov', 
};
